import { axiosInstance } from "./axiosInstance"

export const GET_BANNERS = page => {
  const url = `/api/banners?page=${page}`
  const data = axiosInstance.get(url)
  return data
}